export enum OnboardingTab {
  Profile = 'Profile',
  Company = 'Company',
  Billing = 'Billing',
  Confirm = 'Confirm and Submit',
}
